import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"icon":"","fab":""},on:{"click":function($event){return _vm.$emit('closeClick')}}},[_c(VIcon,{attrs:{"large":""}},[_vm._v("mdi-close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }